import React from "react";
import { Box } from "@flexisaf/flexibull2";

const TagsTab = () => {
  return (
    <Box align="center">
      <h3>Coming Soon</h3>
    </Box>
  );
};

export default TagsTab;
